<template>
	<div class="window window-bg window-alert" :class="{ 'window-lock': btnClose == false }" status="false" @click.self.stop="onClose">
		<div class="body bgContent" windowAlign="center" :class="[sizeClass, { 'body-fullSize': fullSize }]">
			<div class="head bgDesktop">
				<button v-if="btnClose" class="close close-ico bgClose style-close tra-fast fSub hover-f-error" type="button" @click.stop="hide('cancel')">
					<Icon name="close" />
				</button>
				<div class="title dpIB fsLv3">{{ myTitle }}</div>
				<slot name="head"></slot>
			</div>
			<div class="content mt3x" :scroll="scroll ? '' : null">
				<div><slot></slot></div>
			</div>

			<div class="toolBar taR bdSub-top vaM_E" v-if="toolBtnMode === true">
				<!--borderToken_E ml1x_E mr1x_E dpIB_E w7x_E-->
				<button v-if="btnCancel" class="subBtn" :title="btnCancel.text || getLanguageStr('cmd85', '取消')" @click.stop="hide('cancel')" type="button">
					{{ btnCancel.text || getLanguageStr("cmd85", "取消") }}
				</button>
				<!-- 
			<button class="functionBtn close" @click="getList(filterAdvTemp,'filterAdv')" :title="$t('cmd12',['确定'])">{{$t('cmd12',['确定'])}}</button> -->
				<slot name="btmBtn"></slot>
			</div>
			<div v-if="toolBtnMode == 'upDown'" class="upDown"><slot name="btmBtnUD"></slot></div>
		</div>
	</div>
</template>
<script>
import * as lib from "@/util/lib.js";
import { getLanguageStr } from "@/util/language.js";

let timer;
export default {
	name: "WindowForAlert",
	components: {},
	props: {
		title: {
			type: String,
			default: getLanguageStr("phrase623", "请注意"),
		},
		size: {
			type: String,
			default: "s",
		},
		btnClose: {
			// 是否显示关闭按钮
			type: Boolean,
			default: true,
		},
		btnCancel: {
			//取消按钮设置
			// type: Boolean,
			default: () => ({ text: "" }),
		},
		toolBtnMode: {
			type: [String, Boolean],
			default: true,
		},
		scroll: {
			//是否需要配备滚动条
			type: Boolean,
			default: true,
		},
		fullSize: {
			//是否全尺寸内容样式
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			sizeClass: "",
			myTitle: this.title,
		};
	},
	watch: {
		title: function () {
			this.myTitle = this.title;
		},
	},
	created() {},
	methods: {
		getLanguageStr,
		show: function (option) {
			$(this.$el)
				.find(".content")
				.css("max-height", $(window).height() - $(window).height() * 0.08 * 2 - stage.space * (7 + 4 + 4 + 6)); //计算窗口最大高度
			if (option) {
				if (option.title != undefined) this.myTitle = option.title;
				else this.myTitle = this.title;
			}
			this.$nextTick(() => {
				lib.windowCtrl($(this.$el), "true", {
					end: option ? option.end : null,
				});
			});
		},
		hide: function (fn = null) {
			if (fn == "cancel") this.$emit("Cancel");
			this.$emit("Close");
			lib.windowCtrl($(this.$el), "false", {
				end: () => {
					if ($.type(fn) == "function") fn(this.$el);
					this.$emit("Closed");
				},
			});
		},
		onClose: function () {
			if (this.btnClose) {
				this.hide("cancel");
				// setTimeout(() => {
				// 	if ($(this.$el).attr('status') == 'false') this.$emit('Close')
				// }, 0)
			}
		},
	},
	mounted() {
		$(this.$el)
			.find(".content")
			.css("max-height", $(window).height() - $(window).height() * 0.08 * 2 - stage.space * (7 + 4 + 4 + 6)); //计算窗口最大高度
		switch (this.size) {
			case "xs":
				this.sizeClass = "body-xs";
				break;
			case "s":
				this.sizeClass = "body-s";
				break;
			case "m":
				this.sizeClass = "body-m";
				break;
			case "l":
				this.sizeClass = "body-l";
				break;
		}
		let $this = this;
		$(this.$el).on("click", ".toolBar .close", function (e) {
			//close class的dom设置关闭窗口
			e.stopPropagation();
			$this.hide();
		});
		setTimeout(() => {
			lib.setNewScroll($(this.$el).find(".content[scroll]"));
		}, 200);

		// this.$nextTick(()=>{//解决某些情况滚动无效
		// });
	},
};
</script>
<style lang="scss" scoped>
.window {
	&.window-alert {
		z-index: 35;
		.body {
			top: 50%;
		}
		.head {
			background-color: $windowBarBgColor;
			.close {
			}
		}
	}
	// &[status="true"]{opacity:1;}
}
.upDown {
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 1em 0;
}
// .window > .body .toolBar {
// 	margin-top: 3rem;
// 	*{
// 		margin-right: 1rem;
// 	}
// }
</style>



// WEBPACK FOOTER //
// src/components/common/ui/WindowForAlert.vue